import React from 'react';
import { StatusEvent } from './select-events';

export function stylizeEventOption(event) {
    return (
        <div className={'events-picker-options'}>
            <div>
                <div className={'events-picker-options-name'}>{event.name}</div>
                <div className={'events-picker-options-date'}>
                    {new Date(event.start_date).toLocaleDateString([], {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        timeZone: event.timezone
                    }) +
                        ' - ' +
                        event.id}
                </div>
            </div>
            <div>
                <StatusEvent status={event.publication_status} removed={event.removed} />
            </div>
        </div>
    );
}
